module.exports = __webpack_public_path__ + "img/106011.d89222bc.png";